let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8RVgZ")).then(() => parcelRequire('84x8K'));